import React, { Component } from "react";
import bandit from "../images/bandit.avif";
import cauchy from "../images/cauchy2.avif";
import dali from "../images/dali2.avif";
import all from "../images/all3.avif";

const chinchillas = {
  DALI: 0,
  CAUCHY: 1,
  BANDIT: 2,
};

const chinchillaResult = [
  {
    name: "Dalí",
    image: dali,
    altText: "Dalí the chinchilla sitting on the floor, his ears and tail perked up with a content expression on his face",
    text: "You definitely know your worth and carry yourself with pride. You have the charm of a prince but the temper of an evil emperor. Either way, you're royalty and very important to the world.",
  },
  {
    name: "Cauchy",
    image: cauchy,
    altText: "Cauchy the chinchilal sitting on a wooden log with a friendly expression on his face",
    text: "You are loving and kind. You don't discriminate and enjoy surrounding yourself with people. Understandably, everyone wants to be your friend!",
  },
  {
    name: "Bandit",
    image: bandit,
    altText: "Bandit the chinchilla sitting on slab floor tiling, looking a little bit unsure of himself",
    text: "You are a very content person. Sometimes you do not immediately understand what's going on in the world around you, but you don't mind. Just keep on daydreaming!",
  },
];

const questions = [
  {
    question: "Your friend forgets your birthday, how do you react?",
    answers: [
      {
        answer:
          "You immediately end your friendship and their entire bloodline.",
        value: chinchillas.DALI,
      },
      {
        answer:
          "You are disappointed, but you know friendships are so much more than birthday wishes.",
        value: chinchillas.CAUCHY,
      },
      {
        answer: "It's okay, you probably forgot their last birthday too.",
        value: chinchillas.BANDIT,
      },
    ],
  },
  {
    question: "What is your favorite food?",
    answers: [
      {
        answer: "Only the finest international cuisine",
        value: chinchillas.DALI,
      },
      {
        answer: "Home cooked meals are the best!",
        value: chinchillas.CAUCHY,
      },
      {
        answer: "Anything I can chew",
        value: chinchillas.BANDIT,
      },
    ],
  },
  {
    question: "What kind of smart are you?",
    answers: [
      {
        answer: "Street smart",
        value: chinchillas.DALI,
      },
      {
        answer: "Book smart",
        value: chinchillas.CAUCHY,
      },

      {
        answer: "I solve problems with force and sheer will",
        value: chinchillas.BANDIT,
      },
    ],
  },
  {
    question: "What's your goal in life?",
    answers: [
      {
        answer: "World domination.",
        value: chinchillas.DALI,
      },
      {
        answer: "Make as many friends as possible",
        value: chinchillas.CAUCHY,
      },

      {
        answer: "Just sleep in a hammock all day and daydream",
        value: chinchillas.BANDIT,
      },
    ],
  },
];

class Quiz extends Component {
  state = {
    currentQuestion: 0,
    finished: false,
    results: [0, 0, 0],
    starting: true,
  };

  formRef = React.createRef();

  onNextQuestion = (e) => {
    e.preventDefault();
    let questionTarget = "qu" + this.state.currentQuestion;

    let result = e.target[questionTarget].value;
    let newResultsArray = this.state.results;
    newResultsArray[result]++;

    if (this.state.currentQuestion + 1 < questions.length)
      this.setState({
        currentQuestion: this.state.currentQuestion + 1,
        results: newResultsArray,
      });
    else this.setState({ finished: true, results: newResultsArray });
  };

  renderQuestion = (qu, index) => {
    let answers = shuffle(qu.answers).map((ans, ind) => (
      <div key={ind} className="answer">
        <label htmlFor={ind}>
          <input
            type="radio"
            id={ind}
            name={"qu" + index}
            value={ans.value}
            defaultChecked={ind === 0}
          />
          <span className="styled-radio" />
          <span className="answer-text">{ans.answer}</span>
        </label>
      </div>
    ));

    return (
      <div className="question">
        <form ref={this.formRef} onSubmit={this.onNextQuestion}>
          <h4>{qu.question}</h4>
          {answers}

          <button type="submit">
            {index === questions.length - 1
              ? "Show me the results"
              : "Next Question"}
          </button>
        </form>
      </div>
    );
  };

  onReset = () => {
    this.setState({ finished: false, results: [0, 0, 0], currentQuestion: 0 });
  };

  onStart = () => {
    this.setState({ starting: false });
  };

  render() {
    let question = this.renderQuestion(
      questions[this.state.currentQuestion],
      this.state.currentQuestion
    );

    let progressDots = questions.map((qu, index) => (
      <div
        key={index}
        className={
          "dot" + (this.state.currentQuestion === index ? " active" : "")
        }
      />
    ));

    return (
      <div className="quiz" id="quiz" ref={this.props.refName}>
        <div className="section-heading">
          <h1>Quiz</h1>
          <div className="shadow">Quiz</div>
        </div>

        <div className="question-wrapper">
          {this.state.starting ? (
            <div className="starting-state">
              <h3>Which chinchilla is your personality type?</h3>
              <div className="flex-content">
                <div>
                  <p>
                    The three chaos chinchillas are vastly different in their
                    personality. Each of them is special in his own way and has
                    extraordinary qualities that make their trio so perfect.
                  </p>
                  <p>
                    Have you ever wondered whether you are more like the spunky
                    Dalí, the kind Cauchy or maybe the adorable Bandit? Now is
                    your time to find out!
                  </p>
                  <button onClick={this.onStart}>Start the quiz!</button>
                </div>
                <div className="image-wrapper">
                  <img
                    src={all}
                    alt="All three chinchillas all on their back legs, stretchin up high, their faces pressed against the cage bars"
                  />
                </div>
              </div>
            </div>
          ) : this.state.finished ? (
            <div className="finished-state">
              Congratulations! Your personality resembles that of:{" "}
              <div className="flex-content">
                <div>
                  <h3>
                    {
                      chinchillaResult[
                        this.state.results.indexOf(
                          Math.max(...this.state.results)
                        )
                      ].name
                    }
                    !
                  </h3>
                  <p>
                    {
                      chinchillaResult[
                        this.state.results.indexOf(
                          Math.max(...this.state.results)
                        )
                      ].text
                    }
                  </p>
                  <button onClick={this.onReset}>Retake the quiz!</button>
                </div>{" "}
                <div className="image-wrapper">
                  <img
                    src={
                      chinchillaResult[
                        this.state.results.indexOf(
                          Math.max(...this.state.results)
                        )
                      ].image
                    }
                    alt={
                      chinchillaResult[
                        this.state.results.indexOf(
                          Math.max(...this.state.results)
                        )
                      ].altText
                    }
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              {question}
              <div className="quiz-footer">
                <div>
                  {this.state.currentQuestion + 1} / {questions.length}
                </div>
                <div className="dots horizontal">{progressDots}</div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Quiz;

function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}
